var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-actions"},[_vm._t("default",function(){return _vm._l((_vm.allActions),function(action){return _c(action.component,{key:action.label,tag:"component",attrs:{"config":action}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }